/**
 * Main JavaScript file for Protec theme
 */

// Import modules
import { initMobileMenu } from './modules/navigation';
import { initSmoothScroll } from './modules/smooth-scroll';

// DOM Ready
document.addEventListener('DOMContentLoaded', () => {
    console.log('Protec theme loaded');

    // Initialize mobile menu
    initMobileMenu();

    // Initialize smooth scroll
    initSmoothScroll();
});

// Window load
window.addEventListener('load', () => {
    console.log('Window fully loaded');
});
